module.exports = __webpack_public_path__ + "img/riskIconCentre.8c566a23.png";